export default __webpack_public_path__ + "static/media/action-download.bedd2bf4.svg";